import axios from "axios"
import { encriptar } from "../../utilities/encriptacion";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API

export const login = async (email, password) => {
    const data = {
        email: email,
        password: password
    }
    await axios.post(apiUrl + '/monitor/login', data).then((res) => {
        sessionStorage.setItem("token", res.data);
    })

        .catch((error) => {
            Swal.fire({
                icon: "error",
                text: "Credenciales invalidas"
            })
            sessionStorage.setItem("token", "");
            console.log("error", error);

        })
}
export const getHeathTraker = async (id_usuario, navigate) => {

    const dataTracker = {
        id_usuario: id_usuario
    }
    await axios.post(`${apiUrl}/monitor/heathTraker`, dataTracker)
        .then((res_tracker) => {
            if (res_tracker.data.ADD_HEALTH == 1) {
                navigate('/bienestar')
            }
            else {
                const auth = encriptar("true", key);
                sessionStorage.setItem("authMonitor", auth);
                window.location.href = '/';
            }
        })
        .catch((error_tracker) => {
            console.log("error_tracker", error_tracker);

        })
}